exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nbody {\n  margin: 0;\n  overflow: hidden;\n  background-color: #ffffff;\n  font-family: Arial, sans-serif;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/Desktop/agoogle/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/ColeMarsteller/Desktop/agoogle/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/ColeMarsteller/Desktop/agoogle/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles